import { createAsyncThunk } from "@reduxjs/toolkit";
import apiInstance from "config/axiosInstance";

export const GetAllBranches = createAsyncThunk(
  "header/GetAllBranches",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get("branchList");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
